module.exports = __webpack_public_path__ + "static/media/Autonomiq_videoImage.7ec04eb3.png";